import React from 'react'
import Box from '../components/Box'

export default function Section5() {
    return (
        <div className="section">
            <h2>Section V: Scores</h2>
            <Box sectionData={'start'} title={'Record Scores'} body={`Note:  
            • Assignments  may  be  edited  by  selecting  the  “Edit  Assignment”  button  and  following  the 
            instructions in the “Edit Assignment” section.  
            1. Select the class as described previously. 
            2. Select the appropriate assignment from the ‘Assignments’ table. 
            3. A window will appear with a list of students. Enter a score or create an exception (as described 
            in the “Create an Exception” section) for each student. 
            4. A note can be entered by tapping on the field labeled “Tap to add a note...”. Note that a score 
            must be entered before this field is visible. 
            5. Tap “Done”`} />

            <Box title={'Edit a Score'} body={`1. Select the class as described above. 
            2. Select the proper assignment from the Assignments table. 
            3. A window will appear with a list of all students.  Tap the score to be changed. 
            4. Enter the new score or create an exception as described below. 
            5. Tap “Done”.`} />


            <Box title={'Mark All Unscored Assignments'} body={`1. Select the class as described previously.  
            2. Select the proper assignment from the Assignments table.  
            3. Tap “Mark All”.  
            4. Select “Zero Points”, “Exempt”, “100%”, or “Custom Value”.`} />


            <Box title={'Add Assignment Notes'} body={`Note: 
            • Notes can be entered on a per-student basis or for the assignment. This procedure will add a 
            note to the assignment and will not be associated with an individual student. 
            1. Select the class as described previously.  
            2. Select the proper assignment from the Assignments table.  
            3. Tap “Notes”.  
            4. The note field will slide into view.  
            5. Enter or edit assignment notes.  
            6. Tap “Notes” again to hide the note field.`} />

            <Box title={'Create an Exception'} body={`Note:  
            • Quickly create an “Exempt” exemption by entering the letter ‘e’ in the score field. 
            Possible exceptions are: 
            • Dropped:  The  record  of  the  score  is  maintained  but  the  score  does  not  factor  into  the  class 
            grade). 
            • Exempt:  No  record  of  the  score  is  maintained  and  the  assignment  has  no  impact  on  the 
            student’s final grade. 
            • Active, Points Possible Overridden: The possible points are changed for one student only. 
            1. Select the class as described previously. 
            2. Select the assignment as described previously.  
            3. A window will appear with a list of all students.   
            4. Tap the disclosure arrow for the appropriate student. 
            5. Either select “Exempt”, “Dropped” or enter an override value in the field.`} />

            <Box title={'Find Missing Scores'} body={`Notes: 
            • This feature is used to find all students with missing scores on a per-assignment basis.  
            • Exempt, dropped, and zero grades are not shown in this list. 
            1. Select the appropriate class as previously described. 
            2. Tap the “Actions” button on the top toolbar. 
            3. Select “Show Missing Scores”. 
            4. Tap any student in the list to record a missing grade.`} />

            <Box title={'Import Scores test'} body={`Note: 
            • See Section: Importing Scores for details on creating and importing roster files. 
            1. Select the appropriate class as described previously. 
            2. Select an assignment from the Assignments table. 
            3. Tap the “Import” button on the top toolbar. 
            4. Select the file to import.  
                a. Files in the app documents directory are displayed in the list and may be selected.  
                b. On iOS 8.0 and greater select “Other...” to display the system document picker to select 
            files directly from any app that has a document picker available (Dropbox, Box, Google 
            Drive, etc...). `} />

            <Box title={'Configure Short Scorestest'} body={`Note: 
            • Short scores allow letter grades to be entered in place of a numeric score.  The corresponding 
            score  (expressed  as  percent  of  the  total  possible  points  for  the  assignment)  is  automatically 
            calculated.   The  corresponding  weight  must  be  configured  before  use  or  the  entry  will  be 
            ignored.  
            1. Select the appropriate class as described previously. 
            2. Tap ‘Manage’. 
            3. Tap ‘Short Scores’. 
            4. Tap ‘+’. 
            5. Enter a short score and corresponding score. 
            6. Tap ‘Save’. 
            7. Repeat until all short scores are configured and then tap ‘Done’.`} />

            <Box title={'Copy Short Scores'} body={`1. Select the destination class as described previously. 
            2. Tap ‘Manage’. 
            3. Tap ‘Short Scores’. 
            4. Tap ‘Copy’. 
            5. Select the source class. 
            6. Tap ‘Copy’ to complete the operation. 
            7. Tap ‘Done’.`} />

            <Box sectionData={'end'} title={'tEdit a Short Scoreest'} body={`1. Select the appropriate class as described previously. 
            2. Tap ‘Manage’. 
            3. Tap ‘Short Scores’. 
            4. Select the short score that is to be edited. 
            5. Make the desired changes. 
            6. Tap ‘Save’. 
            7. Tap ‘Done’. `} />
        </div>
    )
}